const carouselTrack = document.querySelector('.product-carousel.desktop .carousel-track');
const thumbImages = document.querySelectorAll('.thumb-track img');
const totalSlides = carouselTrack.children.length;
let currentIndex = 0;

function scrollToSlide(index) {
  if (index < 0 || index >= totalSlides) return;
  currentIndex = index;
  carouselTrack.style.transform = `translateX(-${index * 100}%)`;
  thumbImages.forEach((img, i) => {
    img.classList.toggle('active', i === index);
  });
}

scrollToSlide(0);

const track = document.getElementById('mobileCarouselTrack');
const items = track.children;
let currentSlide = 0;
let mobileThumbPage = 0;

function updateMobileCarousel(index) {
  const totalItems = track.children.length;
  const visibleCount = 4;
  const trackEl = document.getElementById('mobileThumbTrack');

  if (index < 0 || index >= totalItems) return;

  currentSlide = index;
  track.style.transform = `translateX(-${index * 100}%)`;
  updateMobileThumbHighlight();

  // Calculate sliding window shift
  const firstVisibleIndex = mobileThumbPage * visibleCount;
  const lastVisibleIndex = firstVisibleIndex + visibleCount - 1;

  if (index < firstVisibleIndex || index > lastVisibleIndex) {
    mobileThumbPage = Math.floor(index / visibleCount);
    const shiftPercent = mobileThumbPage * 103;
    trackEl.style.transform = `translateX(-${shiftPercent}%)`;
  }
}

function updateMobileThumbHighlight() {
  const thumbs = document.querySelectorAll('#mobileThumbTrack img');
  thumbs.forEach((thumb, i) => {
    thumb.classList.toggle('active', i === currentSlide);
  });
}

// Arrow click handler
function stepMobileCarousel(direction) {
  const totalItems = track.children.length;
  const newIndex = currentSlide + (direction === 'right' ? 1 : -1);
  if (newIndex >= 0 && newIndex < totalItems) {
    updateMobileCarousel(newIndex);
  }
}

// Swipe support for mobile carousel
const mobileCarousel = document.getElementById('mobileCarousel');
let touchStartX = 0;
let touchEndX = 0;

mobileCarousel.addEventListener('touchstart', (e) => {
  touchStartX = e.changedTouches[0].screenX;
});

mobileCarousel.addEventListener('touchend', (e) => {
  touchEndX = e.changedTouches[0].screenX;
  handleSwipe();
});

function handleSwipe() {
  const swipeThreshold = 50; // minimum distance to be considered swipe
  const diff = touchEndX - touchStartX;

  if (Math.abs(diff) > swipeThreshold) {
    if (diff < 0) {
      // Swiped left
      stepMobileCarousel('right');
    } else {
      // Swiped right
      stepMobileCarousel('left');
    }
  }
}


// Initial load
updateMobileCarousel(0);
